import buildUUID from '../utils/buildUUID.js'

class Polyline {
  constructor(obj) {
    const { id, url, name, lineWidth, color, opacity, clampToGround, highlight, lineWidthHL, colorHL, opacityHL, crs, flyTo } = obj
    this._id = id ? id : buildUUID()
    this._url = url ? url : ''
    this._name = name ? name : 'polyline'
    this._highlight = highlight || false
    this._highlightOptions = {
      type:'click',
      width: lineWidthHL !== null ? lineWidthHL : 1.0,
      color: colorHL ? colorHL : '#ff0000',
      opacity: opacityHL !== null ? opacityHL : 1.0
    }
    this._styleOptions = {
      width: lineWidth ? lineWidth : 1,
      color: color ? color : '#ff0000',
      opacity: opacity !== null ? opacity : 1.0,
      clampToGround: clampToGround || false,
      highlight: this._highlight ? this._highlightOptions : {},
    }
    this._symbol = {
      type: 'polylineP',
      styleOptions: this._styleOptions
    }
    this._crs = crs ? crs : 'EPSG:4326'
    this._flyTo = flyTo ? flyTo : false
    // 需要传给mars3d.layer.GeoJsonLayer的对象
    this._initObj = {
      id: this._id,
      url: this._url,
      name: this._name,
      symbol: this._symbol,
      crs: this._crs,
      flyTo: this._flyTo
    }
  }
}

Polyline.prototype.addToMap = function(map){
  console.log('执行addToMap!!!')
  var geojsonLayer = new mars3d.layer.GeoJsonLayer(this._initObj);
  map.addLayer(geojsonLayer);
}

export default Polyline
